import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFormState } from '/business/shared/state/actions/application';
import getApplicationIdSelector from '/business/shared/state/selectors/application/getApplicationIdSelector';
import getApplicationCountryCodeSelector from '/business/shared/state/selectors/application/model/getApplicationCountryCodeSelector';
import { saveLocation } from '/shared/state/actions/location';
import isAuthedSelector from '/business/shared/state/selectors/auth/isAuthedSelector';
import getApplicationsSelector from '/business/shared/state/selectors/applications/getApplicationsSelector';
import getSessionTokenSelector from '/shared/state/selectors/getSessionTokenSelector';
import type { LegacyDispatch } from '/business/shared/state/actions/types';

export function ApplicationSync({ enabled = false }: { enabled?: boolean }) {
  const dispatch = useDispatch<LegacyDispatch>();
  const isAuthed = useSelector(isAuthedSelector);
  const token = useSelector(getSessionTokenSelector);
  const applications = useSelector(getApplicationsSelector);
  const applicationId = useSelector(getApplicationIdSelector);
  const applicationCountryCode = useSelector(getApplicationCountryCodeSelector);
  const hasApplications = applications.length > 0;

  useEffect(() => {
    async function syncApplication() {
      if (enabled && isAuthed && hasApplications && applicationId) {
        try {
          await dispatch(getFormState(applicationId));
        } catch (_formStateError) {
          // noop
        }
      }
    }

    syncApplication();
  }, [enabled, isAuthed, dispatch, applicationId, hasApplications]);

  useEffect(() => {
    async function syncCountryLocation() {
      if (enabled && isAuthed && token && applicationCountryCode) {
        try {
          await dispatch(saveLocation({ countryCode: applicationCountryCode, token, useB2BMarkets: true }));
        } catch (_countryCodeError) {
          // noop
        }
      }
    }

    syncCountryLocation();
  }, [enabled, isAuthed, token, applicationCountryCode, dispatch]);

  return null;
}

export default ApplicationSync;
